/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 29da6c02cbd1a4551f5322d52b29b0dd */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type EstimateActions = "CHOOSE_OPTION" | "PROVIDE_USER" | "UPDATE_DATA" | "%future added value";
export type EstimateState = "CALCULATING_OPTIONS" | "COMPLETED" | "CREATED" | "GDPR_CLEANED" | "LEAD_DETAILS_NEEDED" | "NO_OPTIONS_AVAILABLE" | "OPTION_CHOICE_NEEDED" | "REJECTED" | "REJECTED_WITH_LEAD" | "SUPPORT_NEEDED" | "USER_NEEDED" | "VEHICLE_DETAILS_NEEDED" | "%future added value";
export type ScooterPriceEstimate2Input = {
    id?: string | null;
    action: EstimateActions;
    lead?: LeadInput | null;
    attribution?: AttributionInput | null;
    chosenOptionId?: string | null;
    data?: ScooterPriceEstimateDataInput | null;
};
export type LeadInput = {
    phoneNumber?: string | null;
    email?: string | null;
    givenNames?: string | null;
    lastName?: string | null;
    dateOfBirth?: string | null;
};
export type AttributionInput = {
    utmParams?: UTMParamsInput | null;
    testCohorts?: Array<TestingCohortInput> | null;
    featureName?: string | null;
    locationName?: string | null;
};
export type UTMParamsInput = {
    source: string;
    medium?: string | null;
    campaign?: string | null;
    term?: string | null;
    content?: string | null;
    adgroup?: string | null;
};
export type TestingCohortInput = {
    name: string;
    cohort: string;
};
export type ScooterPriceEstimateDataInput = {
    person?: ScooterPriceEstimatePersonInput | null;
    vehicle?: ScooterPriceEstimateVehicleInput | null;
};
export type ScooterPriceEstimatePersonInput = {
    dateOfBirth?: string | null;
    postcode?: string | null;
};
export type ScooterPriceEstimateVehicleInput = {
    registrationNumber?: string | null;
    make?: string | null;
    model?: string | null;
    year?: number | null;
    engineSize?: number | null;
};
export type useScooterEstimateResultMutationVariables = {
    input: ScooterPriceEstimate2Input;
};
export type useScooterEstimateResultMutationResponse = {
    readonly result: {
        readonly estimateResult: {
            readonly state: EstimateState;
            readonly lead?: {
                readonly email: string | null;
                readonly givenNames: string | null;
                readonly lastName: string | null;
                readonly phoneNumber: string | null;
                readonly dateOfBirth: string | null;
            };
            readonly " $fragmentRefs": FragmentRefs<"ScooterQuickEstimatesGbContainer_estimateResult">;
        };
    } | null;
};
export type useScooterEstimateResultMutation = {
    readonly response: useScooterEstimateResultMutationResponse;
    readonly variables: useScooterEstimateResultMutationVariables;
};



/*
mutation useScooterEstimateResultMutation(
  $input: ScooterPriceEstimate2Input!
) {
  result: getScooterPriceEstimate2(input: $input) {
    estimateResult {
      state
      ... on BaseEstimateResult {
        lead {
          email
          givenNames
          lastName
          phoneNumber
          dateOfBirth
        }
      }
      ...ScooterQuickEstimatesGbContainer_estimateResult
      id
    }
  }
}

fragment HeaderPrice_price on Price {
  ...PriceString_price
}

fragment PriceString_price on Price {
  valueDecimal
  currency {
    isoCode
  }
}

fragment QuickEstimatesAuthentication_estimateResult on BaseEstimateResult {
  lead {
    isEmailAvailable
  }
  ...QuickEstimatesLoginForm_estimateResult
  ...QuickEstimatesRegisterForm_estimateResult
}

fragment QuickEstimatesCoverOption_option on EstimateOption {
  rate {
    ...PriceString_price
  }
  product {
    __typename
    frequency
    coverType
    id
  }
}

fragment QuickEstimatesLoginForm_estimateResult on BaseEstimateResult {
  lead {
    email
    isEmailAvailable
  }
}

fragment QuickEstimatesModalOptionsCard_options on EstimateOption {
  ...QuickEstimatesCoverOption_option
  id
  rate {
    ...HeaderPrice_price
  }
  product {
    __typename
    code
    frequency
    coverType
    id
  }
}

fragment QuickEstimatesPersonalDetails_estimateResult on BaseEstimateResult {
  id
}

fragment QuickEstimatesRegisterForm_estimateResult on BaseEstimateResult {
  lead {
    givenNames
    lastName
    phoneNumber
    email
    isEmailAvailable
    dateOfBirth
  }
}

fragment QuickEstimatesRejection_estimateResult on BaseEstimateResult {
  id
  state
  rejection {
    messageHtml
  }
}

fragment QuickEstimatesSupportNeeded_estimateResult on BaseEstimateResult {
  id
  state
  supportNeeded {
    messageHtml
    reason
  }
}

fragment ScooterEstimatesProgressIndicator_estimateResult on ScooterEstimateResult {
  state
}

fragment ScooterQuickEstimatesGbContainer_estimateResult on ScooterEstimateResult {
  id
  state
  ...QuickEstimatesPersonalDetails_estimateResult
  ...QuickEstimatesAuthentication_estimateResult
  ...QuickEstimatesRejection_estimateResult
  ...QuickEstimatesSupportNeeded_estimateResult
  ...ScooterEstimatesProgressIndicator_estimateResult
  ...ScooterQuickEstimatesOptions_estimateResult
  ...ScooterQuickEstimatesVehicle_estimateResult
}

fragment ScooterQuickEstimatesOptions_estimateResult on ScooterEstimateResult {
  id
  assumptions
  options {
    ...QuickEstimatesModalOptionsCard_options
    product {
      __typename
      coverType
      frequency
      id
    }
    id
  }
}

fragment ScooterQuickEstimatesVehicleForm_estimateResult on ScooterEstimateResult {
  id
  data {
    vehicle {
      registrationNumber
      make
      model
      year
      engineSize
    }
  }
}

fragment ScooterQuickEstimatesVehicle_estimateResult on ScooterEstimateResult {
  ...ScooterQuickEstimatesVehicleForm_estimateResult
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ScooterPriceEstimate2Input!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "email",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "givenNames",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "phoneNumber",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "dateOfBirth",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "messageHtml",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "useScooterEstimateResultMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "result",
        "name": "getScooterPriceEstimate2",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "GetScooterPriceEstimate2Payload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimateResult",
            "storageKey": null,
            "args": null,
            "concreteType": "ScooterEstimateResult",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lead",
                "storageKey": null,
                "args": null,
                "concreteType": "Lead",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ]
              },
              {
                "kind": "FragmentSpread",
                "name": "ScooterQuickEstimatesGbContainer_estimateResult",
                "args": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "useScooterEstimateResultMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "result",
        "name": "getScooterPriceEstimate2",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "GetScooterPriceEstimate2Payload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimateResult",
            "storageKey": null,
            "args": null,
            "concreteType": "ScooterEstimateResult",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lead",
                "storageKey": null,
                "args": null,
                "concreteType": "Lead",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isEmailAvailable",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "rejection",
                "storageKey": null,
                "args": null,
                "concreteType": "EstimateResultRejection",
                "plural": false,
                "selections": [
                  (v9/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "supportNeeded",
                "storageKey": null,
                "args": null,
                "concreteType": "EstimateResultSupportNeeded",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "reason",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "assumptions",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "options",
                "storageKey": null,
                "args": null,
                "concreteType": "EstimateOption",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "rate",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Price",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "valueDecimal",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "currency",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Currency",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isoCode",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "product",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "frequency",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "coverType",
                        "args": null,
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "code",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  (v8/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "data",
                "storageKey": null,
                "args": null,
                "concreteType": "ScooterEstimateData",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "vehicle",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ScooterEstimateVehicle",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "registrationNumber",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "make",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "model",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "year",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "engineSize",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "useScooterEstimateResultMutation",
    "id": null,
    "text": "mutation useScooterEstimateResultMutation(\n  $input: ScooterPriceEstimate2Input!\n) {\n  result: getScooterPriceEstimate2(input: $input) {\n    estimateResult {\n      state\n      ... on BaseEstimateResult {\n        lead {\n          email\n          givenNames\n          lastName\n          phoneNumber\n          dateOfBirth\n        }\n      }\n      ...ScooterQuickEstimatesGbContainer_estimateResult\n      id\n    }\n  }\n}\n\nfragment HeaderPrice_price on Price {\n  ...PriceString_price\n}\n\nfragment PriceString_price on Price {\n  valueDecimal\n  currency {\n    isoCode\n  }\n}\n\nfragment QuickEstimatesAuthentication_estimateResult on BaseEstimateResult {\n  lead {\n    isEmailAvailable\n  }\n  ...QuickEstimatesLoginForm_estimateResult\n  ...QuickEstimatesRegisterForm_estimateResult\n}\n\nfragment QuickEstimatesCoverOption_option on EstimateOption {\n  rate {\n    ...PriceString_price\n  }\n  product {\n    __typename\n    frequency\n    coverType\n    id\n  }\n}\n\nfragment QuickEstimatesLoginForm_estimateResult on BaseEstimateResult {\n  lead {\n    email\n    isEmailAvailable\n  }\n}\n\nfragment QuickEstimatesModalOptionsCard_options on EstimateOption {\n  ...QuickEstimatesCoverOption_option\n  id\n  rate {\n    ...HeaderPrice_price\n  }\n  product {\n    __typename\n    code\n    frequency\n    coverType\n    id\n  }\n}\n\nfragment QuickEstimatesPersonalDetails_estimateResult on BaseEstimateResult {\n  id\n}\n\nfragment QuickEstimatesRegisterForm_estimateResult on BaseEstimateResult {\n  lead {\n    givenNames\n    lastName\n    phoneNumber\n    email\n    isEmailAvailable\n    dateOfBirth\n  }\n}\n\nfragment QuickEstimatesRejection_estimateResult on BaseEstimateResult {\n  id\n  state\n  rejection {\n    messageHtml\n  }\n}\n\nfragment QuickEstimatesSupportNeeded_estimateResult on BaseEstimateResult {\n  id\n  state\n  supportNeeded {\n    messageHtml\n    reason\n  }\n}\n\nfragment ScooterEstimatesProgressIndicator_estimateResult on ScooterEstimateResult {\n  state\n}\n\nfragment ScooterQuickEstimatesGbContainer_estimateResult on ScooterEstimateResult {\n  id\n  state\n  ...QuickEstimatesPersonalDetails_estimateResult\n  ...QuickEstimatesAuthentication_estimateResult\n  ...QuickEstimatesRejection_estimateResult\n  ...QuickEstimatesSupportNeeded_estimateResult\n  ...ScooterEstimatesProgressIndicator_estimateResult\n  ...ScooterQuickEstimatesOptions_estimateResult\n  ...ScooterQuickEstimatesVehicle_estimateResult\n}\n\nfragment ScooterQuickEstimatesOptions_estimateResult on ScooterEstimateResult {\n  id\n  assumptions\n  options {\n    ...QuickEstimatesModalOptionsCard_options\n    product {\n      __typename\n      coverType\n      frequency\n      id\n    }\n    id\n  }\n}\n\nfragment ScooterQuickEstimatesVehicleForm_estimateResult on ScooterEstimateResult {\n  id\n  data {\n    vehicle {\n      registrationNumber\n      make\n      model\n      year\n      engineSize\n    }\n  }\n}\n\nfragment ScooterQuickEstimatesVehicle_estimateResult on ScooterEstimateResult {\n  ...ScooterQuickEstimatesVehicleForm_estimateResult\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '2927b90066703ca691955593595920c9';
export default node;
